import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { changeStatusBusinessArea, deleteBusinessArea, getAllBusinessAreas } from "../../../../api/businessArea";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";
import { buttonFormatterEditDisableDelete } from "../../../components/tables/buttonFormatterTable";

export default function TechnologyPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [businessArea, setBusinessArea] = useState(null);

    useEffect(() => {
        getAllBusinessAreas()
            .then((res) => {
                const data = res.data.map(item => ({
                    ...item,
                    title: getNonEmpty(item.title),
                    description: getNonEmpty(item.description),
                    id: item._id,
                }))
                setData(data);
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get business area.' })
            })
    }, [refresh]);


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterEditDisableDelete(cell, "businessArea", data, user?.role === "admin", setBusinessArea, setOpenConfirmDialog, history),
            headerStyle: { width: '200px' }
        }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Business areas list">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-businessArea")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table data={data} columns={columns} key={data.length} />

                    <ConfirmDialog
                        title={`Are you sure you want to ${businessArea?.active ? "deactivate" : "activate"} this business area?`}
                        open={openConfirmDialog === 1}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            changeStatusBusinessArea(businessArea.id, !businessArea?.active)
                                .then((res) => {
                                    alertSuccess({
                                        title: `${businessArea?.active ? "Deactivate!" : "Activate!"
                                            }`,
                                        customMessage: `Business area ${businessArea?.active ? "deactivate" : "activate"
                                            } successfully`,
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: `Could not ${businessArea?.active ? "deactivate" : "activate"
                                            } the business area.`,
                                    });
                                });
                        }}
                    />
                    <ConfirmDialog
                        title={"Are you sure you want to delete this business area?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteBusinessArea(businessArea.id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Business area deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the business area.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}